import SqlDetailView from './SqlDetailView';

export default {
    SqlDetailView,
};

export {
    SqlDetailView,
};